module.exports = new __parcel__URL__("calendar-light.caa4677f.svg").toString();